import { render, staticRenderFns } from "./ComponentWeChatDetail.vue?vue&type=template&id=017e5797&"
import script from "./ComponentWeChatDetail.vue?vue&type=script&lang=js&"
export * from "./ComponentWeChatDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports